/******************************************************************
 * Copyright @ 2023 广州牛师帮文化科技有限公司. All rights reserverd.
 * @file   sso_plugin\src\Tunnel.ts
 * @author Gim
 * @date   2023/01/13 14:12
 * @desc   页面间通讯类
 ******************************************************************/
;
;
;
export class Tunnel {
    constructor(opts) {
        this._fetch_times = 0;
        this._fetch_waitings = new Map();
        this._opened = false;
        this._listeners = {};
        this._responsers = {};
        this._onMessage = (e) => {
            var _a;
            const { signal, origin } = this._opts;
            const data = e.data;
            if (e.origin !== origin || (data === null || data === void 0 ? void 0 : data.signal) !== signal)
                return;
            const { key, value, fetch_id, type = 'msg' } = data;
            if (type == 'msg') {
                (_a = this._listeners[key]) === null || _a === void 0 ? void 0 : _a.map(v => v(value));
            }
            else if (type === 'resp') {
                this._handle_fetch_resp(fetch_id, value);
            }
            else if (type === 'req') {
                this._handle_fetch_req(fetch_id, key, value);
            }
        };
        this._handle_fetch_req = (fetch_id, key, params) => {
            if (!fetch_id) {
                console.error('[Tunnel._handle_fetch_req] fetch_id can not be emoty, this is a Bug.');
                return;
            }
            const responser = this._responsers[key];
            if (!responser) {
                const error = new Error('[Tunnel._handle_fetch_req] responser not found!');
                this._send(key.toString(), [null, error], { type: 'resp', fetch_id });
                return;
            }
            responser(params).then((data) => {
                this._send(key.toString(), [data, null], { type: 'resp', fetch_id });
            }).catch((error) => {
                this._send(key.toString(), [null, error], { type: 'resp', fetch_id });
            });
        };
        this._handle_fetch_resp = (fetch_id, [data, error]) => {
            if (!fetch_id) {
                console.error('[Tunnel._handle_fetch_resp] fetch_id can not be emoty, this is a Bug.');
                return;
            }
            const waiting = this._fetch_waitings.get(fetch_id);
            if (!waiting)
                return;
            this._fetch_waitings.delete(fetch_id);
            clearTimeout(waiting.timer_id);
            if (error) {
                waiting.reject(error);
            }
            else {
                waiting.resolve(data);
            }
        };
        this._handle_fetch_timeout = (fetch_id) => {
            if (!fetch_id) {
                console.error('[Tunnel._handle_fetch_timeout] fetch_id can not be emoty, this is a Bug.');
                return;
            }
            const waiting = this._fetch_waitings.get(fetch_id);
            if (!waiting)
                return;
            this._fetch_waitings.delete(fetch_id);
            waiting.reject(new Error(`[Tunnel.fetch] timeout`));
        };
        this._opts = opts;
        this._opts.open !== false && this.open();
    }
    _send(key, value, data) {
        if (!this._opened)
            return this;
        const { signal, origin, window } = this._opts;
        const msg = Object.assign(Object.assign({}, data), { signal, key, value });
        window.postMessage(msg, origin);
        return this;
    }
    /**
     * 发送数据
     * @param key 数据键
     * @param value 数据值
     * @returns this
     */
    send(key, value) {
        return this._send(key.toString(), value, { type: 'msg' });
    }
    fetch(key, value, opts = {}) {
        if (!this._opened)
            return Promise.reject(new Error('[Tunnel.fetch] Tunnel is not opened'));
        const { signal, origin, window } = this._opts;
        if (!key)
            Promise.reject(new Error('[Tunnel.fetch] key can be empty.'));
        return new Promise((resolve, reject) => {
            const fetch_id = signal + '_' + (++this._fetch_times);
            const msg = {
                signal,
                key: key.toString(),
                value,
                fetch_id,
                type: 'req'
            };
            const { timeout = 5000 } = opts;
            this._fetch_waitings.set(fetch_id, {
                id: fetch_id,
                key: key.toString(),
                timer_id: setTimeout(() => this._handle_fetch_timeout(fetch_id), timeout),
                resolve,
                reject
            });
            window.postMessage(msg, origin);
        });
    }
    resp(key, fn) {
        this._responsers[key.toString()] = fn;
        return this;
    }
    /**
     * 添加数据接收回调
     * @param key 指定接收的数据键
     * @param func 回调，收到key的数据时被调用
     * @returns 返回一个函数，调用可以取消接收数据
     */
    on(key, func) {
        var _a;
        this._listeners[key] = this._listeners[key] || [];
        (_a = this._listeners[key]) === null || _a === void 0 ? void 0 : _a.push(func);
        return () => this.off(key, func);
    }
    /**
     * 移除数据接收回调
     * @param key 指定接收的数据键
     * @param func 需要移除的数据接收回调
     */
    off(key, func) {
        var _a;
        if (!this._listeners[key])
            return;
        this._listeners[key] = (_a = this._listeners[key]) === null || _a === void 0 ? void 0 : _a.filter(v => v !== func);
    }
    open() {
        if (this._opened)
            return;
        this._opened = true;
        window.addEventListener('message', this._onMessage);
    }
    close() {
        if (!this._opened)
            return;
        this._opened = false;
        window.removeEventListener('message', this._onMessage);
    }
}
